import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/termos")({
  head: () => ({
    meta: [
      { title: "Termos de Uso — Rota Norte Express" },
      { name: "description", content: "Termos de uso do site e dos serviços de transporte de passageiros e encomendas da Rota Norte Express." },
      { property: "og:title", content: "Termos de Uso — Rota Norte Express" },
      { property: "og:description", content: "Termos de uso do site e dos serviços da Rota Norte Express." },
      { property: "og:url", content: "https://rotanortexpress.com.br/termos" },
    ],
    links: [{ rel: "canonical", href: "https://rotanortexpress.com.br/termos" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <main className="min-h-screen bg-gradient-to-b from-white via-[#F4F7FC] to-white text-foreground">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-dark/70 hover:text-brand-dark transition-colors">
          <ArrowLeft className="h-4 w-4" /> Voltar para o site
        </Link>
        <h1 className="mt-8 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-brand-dark">Termos de Uso</h1>
        <p className="mt-3 text-sm text-foreground/60">Última atualização: 28 de junho de 2026</p>

        <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-foreground/80">
          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">1. Aceitação dos termos</h2>
            <p className="mt-3">Ao acessar o site da Rota Norte Express e/ou contratar nossos serviços de transporte de passageiros e encomendas, você concorda integralmente com estes Termos de Uso. Caso não concorde, recomendamos que não utilize nossos serviços.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">2. Sobre a empresa</h2>
            <p className="mt-3">A Rota Norte Express é uma empresa brasileira especializada no transporte rodoviário de passageiros e envio de encomendas, operando principalmente nas rotas BR-364 e BR-319, conectando Vilhena (RO), Porto Velho (RO), Manaus (AM) e Rio Branco (AC), com atendimento em cidades ao longo destes trajetos.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">3. Serviços oferecidos</h2>
            <p className="mt-3">Disponibilizamos o transporte interestadual de passageiros e a entrega de encomendas, incluindo cargas comerciais e pessoais, conforme disponibilidade, regras operacionais e horários divulgados pelos nossos canais oficiais.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">4. Reservas e contratação</h2>
            <p className="mt-3">As reservas de assentos e a contratação de envios são realizadas via WhatsApp, telefone ou e-mail oficiais. A confirmação depende de disponibilidade e do pagamento dentro do prazo combinado com a equipe de atendimento.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">5. Responsabilidades do cliente</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2">
              <li>Apresentar documento de identificação válido no embarque.</li>
              <li>Comparecer ao local de embarque com antecedência mínima recomendada.</li>
              <li>Declarar corretamente o conteúdo de encomendas e respeitar a lista de itens proibidos (inflamáveis, ilícitos, armas, perecíveis sem acondicionamento adequado etc.).</li>
              <li>Fornecer dados de contato corretos para entrega.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">6. Responsabilidades da Rota Norte Express</h2>
            <p className="mt-3">Comprometemo-nos a executar o transporte com segurança, pontualidade e cuidado, dentro das condições operacionais da rota. Eventuais atrasos por força maior (condições climáticas, bloqueios em rodovias, ações de autoridades) serão comunicados o quanto antes pelos nossos canais.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">7. Política de cancelamento e reembolso</h2>
            <p className="mt-3">Cancelamentos e remarcações devem ser solicitados via WhatsApp com a maior antecedência possível. As condições de reembolso seguem a legislação aplicável e podem variar conforme a antecedência do pedido.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">8. Limitação de responsabilidade</h2>
            <p className="mt-3">Não nos responsabilizamos por valores em dinheiro, joias, eletrônicos sem declaração prévia, documentos originais ou objetos frágeis enviados sem o devido acondicionamento e seguro adicional.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">9. Propriedade intelectual</h2>
            <p className="mt-3">Todo o conteúdo deste site — textos, logotipos, imagens, ícones e identidade visual — é de propriedade da Rota Norte Express e não pode ser reproduzido sem autorização prévia.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">10. Alterações nos termos</h2>
            <p className="mt-3">Estes Termos podem ser atualizados a qualquer momento. A versão vigente estará sempre disponível nesta página, com a data da última revisão.</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark">11. Contato</h2>
            <p className="mt-3">Dúvidas sobre estes Termos podem ser enviadas para <a className="text-brand-dark font-semibold hover:underline" href="mailto:contato@rotanortexpress.com.br">contato@rotanortexpress.com.br</a>.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
